export const GITHUB_TYPE = {
  GITHUBCODES: "GITHUBCODES",
  IS_LOADING: "IS_LOADING",
};
